module.exports = __webpack_public_path__ + "static/media/bottle_img.c00f3735.png";